import { styled } from "@mui/system";
export const BadgeContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
